import { createActionReport } from '@/reporter/actionReport';
import { Module } from '@/reporter/type';
export const runtimeSidebarActionReport = createActionReport(Module.RuntimeSidebar);
